import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import { DocsInterface, type DocsInterfaceProps } from "../../../../../../src/chrome/DocsInterface";
import { colors, SplashCard, SplashCardGrid, SplashContentContainer } from "../../../../../../src/components/SplashPage";

const ConnectionQuickstarts = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Advanced topics</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn about more complex Shopify topics ranging from extensions to OAuth.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Data security"
            color={colors.white}
            body="Learn how to keep your merchants' data safe."
            href="/guides/plugins/shopify/advanced-topics/data-security"
            copy="Get started →"
          />
          <SplashCard
            title="Metafields & metaobjects"
            color={colors.white}
            body="Learn how to use metadata in your Gadget application."
            href="/guides/plugins/shopify/advanced-topics/metafields-metaobjects"
            copy="Get started →"
          />
          <SplashCard
            title="OAuth"
            color={colors.white}
            body="Learn how Gadget implemented OAuth for the Shopify connection."
            href="/guides/plugins/shopify/advanced-topics/oauth"
            copy="Get started →"
          />
          <SplashCard
            title="Billing"
            color={colors.white}
            body="Learn how to bill merchants for your applications."
            href="/guides/plugins/shopify/advanced-topics/billing"
            copy="Get started →"
          />
          <SplashCard
            title="shopify.app.toml files"
            color={colors.white}
            body="Learn how to set up your shopify.app.toml file in a Gadget application."
            href="/guides/plugins/shopify/advanced-topics/shopify-app-toml"
            copy="Get started →"
          />
          <SplashCard
            title="Building extensions"
            color={colors.white}
            body="Learn how to build Shopify extensions in your Gadget application."
            href="/guides/plugins/shopify/advanced-topics/extensions"
            copy="Get started →"
          />
          <SplashCard
            title="Customer account UI extensions & authentication"
            color={colors.white}
            body="Learn how to use your Gadget application in a customer account UI extension."
            href="/guides/plugins/shopify/advanced-topics/customer-account-ui-extensions"
            copy="Get started →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ConnectionQuickstarts;
